import { createContext, useContext } from 'react';

const ConnectContext = createContext(() => {});
export const useOpenConnect = () => useContext(ConnectContext);
export default ConnectContext;
